// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import animate from 'animate.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import { VueHammer } from 'vue2-hammer'

Vue.config.productionTip = false

Vue.use(animate)
Vue.use(VueCookies)

axios.defaults.baseURL=NetWorkConfig.baseURL
axios.defaults.timeout=NetWorkConfig.timeout
axios.defaults.headers=NetWorkConfig.headers

Vue.use(VueAxios, axios)
Vue.use(VueHammer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js